/**
 * 后端接口地址
 */
export const Config = {
  /**
   * 获取消息列表
   */
  getMessageList: 'GET /message/list',

  /**
   * 获取未读消息数
   */
  getUnReadMessageCount: 'GET /message/unread-count'
}
